import emoji from "react-easy-emoji";

import googlelogo from "./assets/img/icons/common/google.svg";
import github from "./assets/img/icons/common/github.svg";

import marketiveLogo from "./assets/img/logos/marketive.png";
import lynxLogo from "./assets/img/logos/lynx.jpg";
import FurtherLogo from "./assets/img/logos/further.png";
import camelcodingLogo from "./assets/img/logos/camelcoding.jpg";

import vueLogo from "./assets/img/logos/vue.png";
import laravelLogo from "./assets/img/logos/laravel.png";
import bulmaLogo from "./assets/img/logos/bulma.png";
import pixiLogo from "./assets/img/logos/pixijs.png";
import threejsLogo from "./assets/img/logos/threejs.png";
import unityLogo from "./assets/img/logos/unity.svg";

import theRide from "./assets/img/projects/theride.png";
import restaurant from "./assets/img/projects/restaurant.png";
import fitness from "./assets/img/projects/fitness.png";
import quiz from "./assets/img/projects/quiz.png";
import credentialCalculator from "./assets/img/projects/mandatumkalkulator.png";
import wape from "./assets/img/projects/wape.png";
import meditation from "./assets/img/projects/meditation.png";

import sirReginald from "./assets/img/projects/sirReginald.png";
import soldierOfOrban from "./assets/img/projects/soldierOfOrban.jpg";
import speedyHamby from "./assets/img/projects/speedyHamby.png";
import keysOfRhapsody from "./assets/img/projects/keysOfRhapsody.png";
import quickDrawDuel from "./assets/img/projects/quickDrawDuel.png";
import lolMemoryGame from "./assets/img/projects/lolMemoryGame.png";
import spaceCommander from "./assets/img/projects/spaceCommander.png";
import bomberDodger from "./assets/img/projects/bomberDodger.png";
import blackjack from "./assets/img/projects/blackjack.png";
import glados from "./assets/img/projects/glados.png";
import typeThatTune from "./assets/img/projects/TypeThatTune.jpg";

import hoh from "./assets/img/projects/hoh.png";
import diploma from "./assets/img/projects/diploma.png";
import vuePixi from "./assets/img/projects/vuePixi.png";

import panzerVideo from "./assets/videos/panzer.mkv";
import pirateVideo from "./assets/videos/pirate.mkv";
import pianoVideo from "./assets/videos/piano.mkv";


export const greetings = {
	name: "Benedek Szabolcs",
	title: "Hi all, I'm Szabi",
	description:
		"I’m a passionate Full Stack Web and Game Developer with experience in building dynamic applications using JavaScript, Vue.js, PixiJS, Laravel, Firebase, and various other modern libraries and frameworks.",
	resumeLink: "https://drive.google.com/file/d/1Ood8qsHWnyKSEffG4vSpIayLr15j7VbZ/view?usp=sharing",
};

export const openSource = {
	githubUserName: "benedek1239",
};

export const contact = {};

export const socialLinks = {
	facebook: "https://www.facebook.com/szabi.benedek",
	github: "https://github.com/benedek1239",
	linkedin: "https://www.linkedin.com/in/szabolcs-benedek-3187431b5/",
};

export const skillsSection = {
	title: "What I do",
	subTitle:
		" FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
	skills: [
			" ♦ Develop highly interactive and responsive Front end / User Interfaces for your web and mobile applications",
			" ♦ Developing Browser and Desktop Games with JavaScript or Unity",
			" ♦ Using Back end Frameworks, Libraries and Technologies"
	],

	softwareSkills: [
		{
			skillName: "html-5",
			fontAwesomeClassname: "vscode-icons:file-type-html",
		},
		{
			skillName: "css3",
			fontAwesomeClassname: "vscode-icons:file-type-css",
		},
		{
			skillName: "sass",
			fontAwesomeClassname: "logos:sass",
		},
		{
			skillName: "JavaScript",
			fontAwesomeClassname: "logos:javascript",
		},
		{
			skillName: "TypeScript",
			fontAwesomeClassname: "logos:typescript-icon",
		},
		{
			skillName: "npm",
			fontAwesomeClassname: "vscode-icons:file-type-npm",
		},
		{
			skillName: "sql-database",
			fontAwesomeClassname: "vscode-icons:file-type-sql",
		},
		{
			skillName: "mongoDB",
			fontAwesomeClassname: "vscode-icons:file-type-mongo",
		},
		{
			skillName: "firebase",
			fontAwesomeClassname: "logos:firebase",
		},
		{
			skillName: "git",
			fontAwesomeClassname: "logos:git-icon",
		}
	],
	
	moreSoftwareSkills: [
		{
			skillName: "vuejs",
			skillLogo: vueLogo,
		},
		{
			skillName: "Laravel",
			skillLogo: laravelLogo,
		},
		{
			skillName: "bulma",
			skillLogo: bulmaLogo,
		},
		{
			skillName: "pixijs",
			skillLogo: pixiLogo,
		},
		{
			skillName: "Unity",
			skillLogo: unityLogo,
		},
        {
			skillName: "ThreeJS",
			skillLogo: threejsLogo,
		},
	]

};

export const SkillBars = [
	{
		Stack: "Frontend",
		progressPercentage: "85", 
	},
	{
		Stack: "Backend",
		progressPercentage: "60",
	},
	{
		Stack: "Game Programming",
		progressPercentage: "70",
	},
];

export const educationInfo = [
	{
		schoolName: "Sapientia University",
		subHeader: "Computer Science",
		duration: "September 2017 - June 2021",
		desc: "Graduated with a degree in electrical engineering.",
		descBullets: [
			"Electrical Engineering degree, with a strong foundation in both hardware and software aspects of digital devices",
			"Hands-on experience with modern frameworks and libraries, continuously improving my knowledge",
			"Open to internship opportunities where I can apply my skills and gain practical industry experience",
		],
	},
	{
		schoolName: "Joannes Kajoni",
		subHeader: "Tourism and English",
		duration: "September 2013 - June 2017",
		desc: "Earned a graduation diploma and completed an English thesis.",
		descBullets: [
			"Improved English grammar and communication skills",
			"Gained insights into the tourism industry",
			"Learned to collaborate effectively with people from diverse backgrounds"
		],
	},
];

export const experience = [
    {
		role: "Game Developer",
		company: "Camel Coding",
		companylogo: camelcodingLogo,
		date: "May 2022 – Present",
		desc: "We are developing online casino games using PixiJS, powered by a unique, custom-built game engine. Our growing team, based in Transylvania, is dedicated to creating innovative and engaging gaming experiences.",
		url: "https://www.camelcoding.com/"
	},
	{
		role: "Full-Stack Developer",
		company: "GoFurther Digital",
		companylogo: FurtherLogo,
		date: "February 2021 – May 2022",
		desc: "Collaborating with multiple clients, I’ve been involved in developing diverse applications using the latest technologies. Most of these projects focused on Laravel and Vue.js, built together with a talented and supportive team.",
		url: "https://gofurther.digital/en"
	},
	{
		role: "Web Developer Intern",
		company: "The Marketive",
		companylogo: marketiveLogo,
		date: "July 2020 – Sept 2020",
		desc: "Together with a friend, I developed an online travel companion finder application using Laravel. Through this project, we also connected with a professional local team in our hometown, which opened new opportunities for collaboration.",
		url: "https://themarketive.com/"
	},
	{
		role: "Web Developer Intern",
		company: "Lynx Solutions",
		companylogo: lynxLogo,
		date: "July 2019 – Sept 2019",
		desc: "Together with fellow university students, I developed a React-based application — a complex, multi-functional teaching interface designed to support education with modern technology.",
		url: "https://www.lynxsolutions.eu/"
	},
];

export const websites = [
	{
		name: "Meditation App",
		desc: "Daily humming meditation app. Hold the tone to light up every region, from chest to crown, to complete your practice.",
		img: meditation,
		link: "https://zonges-meditacio.web.app",
	},
	{
		name: "The Ride",
		desc: "Online travel companion finder Application, made in Laravel. This website was my state exam at Sapientia university.",
		img: theRide,
		link: "https://github.com/benedek1239/TheRide",
	},
	{
		name: "Game of Thrones quiz",
		desc: "Highly interactive quiz applcication, for hardcore Game of Thrones fans. Made for fun.",
		img: quiz,
		link: "https://quiz-c4bfb.firebaseapp.com/",
	},
	{
		name: "Restaurant Webpage",
		desc: "Site of a restaurant in my home town, where users can order food. Made for a friend.",
		img: restaurant,
		link: "https://restaurant-hosting.web.app/",
	},
    {
		name: "Credential Calculator",
		desc: "Crecential Calculator for the 2022 Hungarian parliamentary elections.",
		img: credentialCalculator,
		link: "https://mandatumkalkulator.atlatszo.hu",
	},
    {
		name: "Airwape Product Page",
		desc: "A single page product site for selling airwapes, including javascript aniamtions on mobile.",
		img: wape,
		link: "https://airvapeusa.com/products/airvape-legacy-pro",
	},
	{
		name: "GYM Webpage",
		desc: "A website for GYM owners and for their clients to managing tickets. It was a university project from .Net course.",
		img: fitness,
		link: "https://github.com/benedek1239/Fitness",
	},

];

export const games = [
	{
		name: "Bomber Dodger",
		desc: "Player vs player stategy, action game in a friendly environment. Inspired by the classic Bomberman.",
		img: bomberDodger,
		link: "https://benedekszabolcs.itch.io/bomber-dodger",
	},
	{
		name: "Project GLaDOS",
		desc: "A brainstorming and problem-solving dice-placing game, which is a digital version of the board game Doom Machine.",
		img: glados,
		link: "https://project-glados.web.app/",
	},
	{
		name: "Sir Reginald",
		desc: "Adventure Role Playing Game with a kind knight sir Reginald. He wants to save his pride, Lady Magdolna.",
		img: sirReginald,
		link: "https://benedekszabolcs.itch.io/crusader",
	},
    {
		name: "Quickdraw Duel",
		desc: "A skill-based card game where you have to be faster then the AI to deplete your deck first.",
		img: quickDrawDuel,
		link: "https://benedekszabolcs.itch.io/quickdraw-duel",
	},
    {
		name: "Type That Tune",
		desc: "This is a typing game where you have to enter the lyrics of various songs or scenes, testing your speed and focus.",
		img: typeThatTune,
		link: "https://benedekszabolcs.itch.io/type-that-tune",
	},
	{
		name: "The Soldier of Viktor Orban",
		desc: "Top-down zombie shooter game, but this time the player needs to help Viktor Orban to defend the border of Hungary.",
		img: soldierOfOrban,
		link: "https://benedekszabolcs.itch.io/the-soldier-of-orban-viktor",
	},
    {
		name: "Special Black Jack",
		desc: "Real Time Strategy Online PvP Card Game. It's not a simple Black Jack, Special Cards makes the Gameplay more fun.",
		img: blackjack,
		link: "https://specialblackjack.herokuapp.com/",
	},
	{
		name: "Space Bounty",
		desc: "Classic Shootem Up styled Space Ship Game. The Bounty Hunter needs to eliminate the Big Pirate Boss and his Bandits.",
		img: spaceCommander,
		link: "https://benedekszabolcs.itch.io/space-bounty/",
	},
	{
		name: "Speedy Hamby",
		desc: "A Hamburger maker Game, where the player must use his speed and attention if he wants to do the order well.",
		img: speedyHamby,
		link: "https://benedekszabolcs.itch.io/speedy-hamby",
	},
	{
		name: "Keys of Rhapsody",
		desc: "An interactive piano rhythm game that requires a lot of practice. Playable with MIDI keyboard.",
		img: keysOfRhapsody,
		link: "https://benedekszabolcs.itch.io/keys-of-rhapsody",
	},
	{
		name: "LoL Memory Game",
		desc: "Classic Card Memory Game, with LoL Champions and Hearthstone cards, because I love both of this games.",
		img: lolMemoryGame,
		link: "https://benedekszabolcs.itch.io/league-of-legends-memory-game",
	},

];

export const projects = [
    {
        name: "Heroes of Holdem",
		desc: "I was one of the lead front-end developers on Heroes of Holdem, an online RPG poker game with a React-based Lobby and a Pixi.js-powered game. We built a fully custom engine in-house to meet our unique requirements. This project accelerated my growth as a developer, pushing me to create innovative, web-optimized solutions for rich animations, sound, and immersive gameplay.",
		img: hoh,
		link: 'https://www.youtube.com/watch?v=ORZppbeAg3Y&ab_channel=HeroesofHoldem'
	},
    {
        name: "Diploma Thesis",
		desc: "The web application built for the exam has been named „The Ride” and the purpose behind is to create a well designed and responsive platform for people who want to travel, commute and explore. My goal for the application was to be able to create the entire route when adding a newride, as well as to provide breakdown of locations that the ride is passing through. It’s crucial that the users are provided with good recommendations for rides.",
		img: diploma,
		link: 'https://drive.google.com/file/d/12VLd9w89Jth40zd-zkgB5hQ_Rld0tpge/view?usp=sharing'
	},
	{
        name: "Upwork Project",
		desc: "The component is designed to display a floorplan image with markers positioned dynamically according to specified x and y coordinates. It is fully responsive, adapting smoothly to window resizing. Each marker supports interactive behavior: clicking a marker opens a link, while hovering triggers an animation and displays a popup. Additionally, some markers feature a pulse effect to draw attention and enhance the visual experience.",
		img: vuePixi,
		link: 'https://floorplan-cfebd.web.app/#/'
	}

];


export const designs = [
	{
		name: "Pirate",
		desc: "A Pirate style, really atmospheric menu, for a future Pirate game. The inspiration came from a great song, the Wellerman.",
		video: pirateVideo,
	},
	{
		name: "Panzer",
		desc: "The inspiration behind this plan, is an old panzer game I used to play with when I was a kid. I stole the logo from World of Tanks.",
		video: panzerVideo,
	},
	{
		name: "Piano",
		desc: "A relaxing menu with an actually working rhythm game. The game works only with my Midi Piano Controller. Made it for myself to make it easier to learn to play the piano ",
		video: pianoVideo,
	},

];


export const prof = {
	avatar_url: "https://avatars.githubusercontent.com/u/52738472?s=400&u=2bf1862e90599d6454d998f3369d519b0b9c0977&v=4",
	location: "Csíkszereda",
	linkedin: "https://www.linkedin.com/in/szabolcs-benedek-3187431b5/",
};
